import { createSlice } from '@reduxjs/toolkit';
import { VIEW_MODES } from './utils/constants';

const initialState = {
  selectedPoolId: null,
  selectedCandidateId: null,
  viewMode: VIEW_MODES.LIST,
  showDetailsDrawer: false,
  sidebarCollapsed: false,
};

const candidatePoolingSlice = createSlice({
  name: 'candidatePooling',
  initialState,
  reducers: {
    setSelectedPool: (state, { payload }) => {
      state.selectedPoolId = payload;
      state.selectedCandidateId = null;
      state.showDetailsDrawer = false;
    },
    setSelectedCandidate: (state, { payload }) => {
      state.selectedCandidateId = payload;
      state.showDetailsDrawer = !!payload;
    },
    setViewMode: (state, { payload }) => {
      state.viewMode = payload;
    },
    setShowDetailsDrawer: (state, { payload }) => {
      state.showDetailsDrawer = payload;
    },
    setSidebarCollapsed: (state, { payload }) => {
      state.sidebarCollapsed = payload;
    },
    resetCandidatePooling: () => initialState,
  },
});

export const {
  setSelectedPool,
  setSelectedCandidate,
  setViewMode,
  setShowDetailsDrawer,
  setSidebarCollapsed,
  resetCandidatePooling,
} = candidatePoolingSlice.actions;

export const getSelectedPoolId = (state) => state.candidatePooling?.selectedPoolId;
export const getSelectedCandidateId = (state) => state.candidatePooling?.selectedCandidateId;
export const getViewMode = (state) => state.candidatePooling?.viewMode;
export const getShowDetailsDrawer = (state) => state.candidatePooling?.showDetailsDrawer;

export default candidatePoolingSlice.reducer;
